import { DEFAULT_STARTING_VOLTAGE, DEFAULT_STARTING_VOLTAGE_FOR_CUSTOM, DEFAULT_STARTING_VOLTAGE_FOR_YD } from '../constants';
import { LoadType, StartingType } from '../enums';
import { CommonData, LoadData, MesRequest } from '../models';
import { ceil, round } from './RoundService';

export const getDefaultLoadData = (loadType: LoadType, mesRequest: MesRequest) => {
    const { mn, nN } = mesRequest.commonData;
    const mnAsNumber = Number(mn);
    const nNAsNumber = Number(nN);
    const defaultLoadData: LoadData = {
        loadType,
        n0: null,
        n1: null,
        n2: null,
        n3: null,
        n4: null,
        m0: null,
        m1: null,
        m2: null,
        m3: null,
        m4: null
    };

    switch (loadType) {
        case LoadType.QuadraticWithoutBreakaway:
            defaultLoadData.n0 = 0;
            defaultLoadData.m0 = 0;
            defaultLoadData.n4 = nN;
            defaultLoadData.m4 = mn;
            break;
        case LoadType.QuadraticWithBreakaway:
            defaultLoadData.n0 = 0;
            defaultLoadData.m0 = round(mnAsNumber / 3, 2);
            defaultLoadData.n1 = round(nNAsNumber / 5, 2);
            defaultLoadData.m1 = round(mnAsNumber / 7, 2);
            defaultLoadData.n4 = nN;
            defaultLoadData.m4 = mn;
            break;
        case LoadType.Constant:
            defaultLoadData.m4 = mn;
            break;
        case LoadType.Linear:
            defaultLoadData.n0 = 0;
            defaultLoadData.m0 = round(mnAsNumber / 3, 2);
            defaultLoadData.n4 = nN;
            defaultLoadData.m4 = mn;
            break;
        case LoadType.NoLoad: {
            defaultLoadData.n0 = 0;
            defaultLoadData.m0 = 0;
            defaultLoadData.n4 = nN;

            const defaultM4 = 0.02 * mnAsNumber;
            defaultLoadData.m4 = ceil(defaultM4, defaultM4 < 100 ? 1 : 0);
            break;
        }
        case LoadType.Custom: {
            let defaultM0 = 0.05 * mnAsNumber;
            defaultM0 = ceil(defaultM0, defaultM0 < 100 ? 1 : 0);

            defaultLoadData.n0 = 0;
            defaultLoadData.m0 = defaultM0;
            defaultLoadData.n1 = 0;
            defaultLoadData.m1 = defaultM0;
            defaultLoadData.n2 = 0;
            defaultLoadData.m2 = defaultM0;
            defaultLoadData.n3 = 0;
            defaultLoadData.m3 = defaultM0;
            defaultLoadData.n4 = nN;
            defaultLoadData.m4 = mn;
            break;
        }
    }

    return defaultLoadData;
};


export const getNw = ({ nw, nwWithTolerance, isBreakdownToleranceOn, isLockedRotorPullupToleranceOn }: CommonData) =>
    isBreakdownToleranceOn && isLockedRotorPullupToleranceOn
        ? nwWithTolerance
        : nw;

export const getStartingVoltageByType = (type: StartingType, loadType: LoadType) =>
    type === StartingType.YD
        ? DEFAULT_STARTING_VOLTAGE_FOR_YD
        : getDefaultStartingVoltage(loadType);

export const getDefaultStartingVoltage = (loadType: LoadType) => loadType === LoadType.Custom ? DEFAULT_STARTING_VOLTAGE_FOR_CUSTOM : DEFAULT_STARTING_VOLTAGE;
